// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"df2c3500","119":"b9bfb97f","381":"7d285e33","494":"2cd6a355","783":"353378ff","886":"e61e4c0c","990":"9c4a6701"}[chunkId] + ".chunk.js";
};